import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { UzurvDirectivesModule } from '@uzurv/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranistProgramOperatingScheduleDialogComponent } from './transit-program-operating-schedule-dialog.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    UzurvDirectivesModule
  ],
  declarations: [TranistProgramOperatingScheduleDialogComponent],
  exports: [TranistProgramOperatingScheduleDialogComponent]
})
export class TransitProgramOperatingScheduleDialogModule {}
